export default "__VITE_PUBLIC_ASSET__68484b9c__"